import {default as cx} from "classnames"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"

import {ProgressRating} from "./ProgressRating"


const STATUS_ALIASES = {not_required: "not-due", required: "missing"}
const KNOWN_STATUSES = new Set(["submitted", "not-due", "missing"])

// Accepts the three string statuses, plus legacy booleans from callers that haven't moved over yet
const normalizeStatus = (status) => {
    if (status === true) return "submitted"
    if (status === false) return "missing"
    const mapped = STATUS_ALIASES[status] ?? status
    return KNOWN_STATUSES.has(mapped) ? mapped : null
}

const SurveyStatus = ({label, status}) => {
    const normalized = normalizeStatus(status)
    if (normalized === null) return null

    return (
        <span className={cx("fw-semibold fs-5 ms-4", {"text-danger": normalized === "missing"})}>
            {normalized === "not-due" ? (
                <OverlayTrigger
                    placement="top"
                    trigger={["hover", "focus"]}
                    overlay={
                        <Tooltip id={`${label.toLowerCase()}-not-due-tooltip`}>
                            An {label} is not due this week.
                        </Tooltip>
                    }
                >
                    <span role="img" aria-label={`${label} not due`} className="me-1">
                        <i className="fas fa-circle-info text-info fs-5"></i>
                    </span>
                </OverlayTrigger>
            ) : normalized === "submitted" ? (
                <i className="fas fa-circle-check text-success me-1 fs-5"></i>
            ) : (
                <i className="fas fa-exclamation-triangle text-danger me-1 fs-5"></i>
            )}
            {label}
        </span>
    )
}

export const ProgressCardHeader = ({
    badge,
    name,
    osr,
    osrSubmissionStatus,
    nhsrSubmissionStatus,
    progressReport,
    progressReportWarning,
    futureStartDate = false,
}) => {
    return (
        <div className="card-header px-4 flex-column flex-sm-row align-items-stretch align-items-sm-center gap-3">
            <h3 className="card-title fw-bold flex-wrap gap-2 align-items-start align-items-sm-center mb-0 px-2 py-4">
                {name}:
                <div className={`badge badge-lg ${badge.background} ${badge.textColor} ms-2 me-5 px-6 py-2 fs-7`}>
                    {badge.badge}
                </div>
                {!futureStartDate && (
                    <>
                        <ProgressRating
                            report={progressReport}
                            outdatedWarning={progressReportWarning}
                            variant="summary"
                        />
                        <SurveyStatus label="OSR" status={osrSubmissionStatus} />
                        <SurveyStatus label="NHSR" status={nhsrSubmissionStatus} />
                    </>
                )}
            </h3>
        </div>
    )
}
